var polyline = null

function currentListOfPoints() {
  let listOfPoints = []

  window.map.eachLayer(function (layer) {
    if (layer.getLatLng) { listOfPoints.push(layer.getLatLng()) }
  });

  return listOfPoints;
}

function removeAllPoints() {
  window.map.eachLayer(function (layer) {
    if (layer.getLatLng) { map.removeLayer(layer) }
  });
}

function addMarker(latlng) {
  L.marker(latlng, {draggable: true}).addTo(window.map).on('click', function(e) {
    window.map.removeLayer(e.target)
    refreshItinary()
    pushHistoryState()
  }).on('moveend', (e) => { // TODO: change to on move?
    refreshItinary()
    pushHistoryState()
  });
}

function showPathCoordinates(pathCoordinates) {
  if (polyline) { polyline.remove() }

  if (pathCoordinates) { polyline = L.polyline(pathCoordinates, {color: 'red'}).addTo(window.map) }
}

function initializeMap() {
  window.map = L.map('map', {maxZoom: 16}).fitBounds([
    [42.437969, -4.891829],
    [51.073113, 7.663783]
  ]);

  L.tileLayer(
    `https://data.geopf.fr/private/wmts?` +
    "&REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0" +
    "&STYLE=normal" +
    "&TILEMATRIXSET=PM" +
    "&FORMAT=image/jpeg"+
    "&LAYER=GEOGRAPHICALGRIDSYSTEMS.MAPS"+
    "&TILEMATRIX={z}" +
    "&TILEROW={y}" +
    "&TILECOL={x}" +
    "&apikey=ign_scan_ws",
    {
      minZoom:0,
      maxZoom:18,
      attribution : "IGN-F/Geoportail",
      tileSize:256
    }
  ).addTo(window.map) ;

  window.map.on('click', (e) => {
    addMarker(e.latlng)

    refreshItinary()
    pushHistoryState()
  });
}


export { initializeMap, showPathCoordinates, addMarker, currentListOfPoints, removeAllPoints}

